import '@fontsource/domine/latin-400.css';
import '@fontsource/domine/latin-ext-400.css';
import '@fontsource/domine/latin-500.css';
import '@fontsource/domine/latin-ext-500.css';
import '@fontsource/domine/latin-600.css';
import '@fontsource/domine/latin-ext-600.css';
import '@fontsource/domine/latin-700.css';
import '@fontsource/domine/latin-ext-700.css';
import '@fontsource/lato/latin-100.css';
import '@fontsource/lato/latin-ext-100.css';
import '@fontsource/lato/latin-100-italic.css';
import '@fontsource/lato/latin-ext-100-italic.css';
import '@fontsource/lato/latin-300.css';
import '@fontsource/lato/latin-ext-300.css';
import '@fontsource/lato/latin-300-italic.css';
import '@fontsource/lato/latin-ext-300-italic.css';
import '@fontsource/lato/latin-400.css';
import '@fontsource/lato/latin-ext-400.css';
import '@fontsource/lato/latin-400-italic.css';
import '@fontsource/lato/latin-ext-400-italic.css';
import '@fontsource/lato/latin-700.css';
import '@fontsource/lato/latin-ext-700.css';
import '@fontsource/lato/latin-700-italic.css';
import '@fontsource/lato/latin-ext-700-italic.css';
import '@fontsource/lato/latin-900.css';
import '@fontsource/lato/latin-ext-900.css';
import '@fontsource/lato/latin-900-italic.css';
import '@fontsource/lato/latin-ext-900-italic.css';
